import * as Sentry from "@sentry/react";

import { isExpectedLoginAuthError } from "../../../utilities/auth-errors";

function getCurrentPathname(): string {
  if (typeof location === "undefined") {
    return "";
  }

  return location.pathname;
}

function getSentryEventExceptionMessage(
  event: Sentry.ErrorEvent,
): string | undefined {
  const firstException = event.exception?.values?.[0];
  if (!firstException) {
    return undefined;
  }

  return firstException.value;
}

export function isLoginRoute(pathname: string): boolean {
  if (pathname === "/login") {
    return true;
  }

  return pathname === "/login/";
}

export function isExpectedLoginError(
  event: Sentry.ErrorEvent,
  hint: Sentry.EventHint,
): boolean {
  if (!isLoginRoute(getCurrentPathname())) {
    return false;
  }

  if (isExpectedLoginAuthError(hint.originalException)) {
    return true;
  }

  const eventExceptionMessage = getSentryEventExceptionMessage(event);
  if (!eventExceptionMessage) {
    return false;
  }

  return isExpectedLoginAuthError({
    message: eventExceptionMessage,
  });
}
